import type { SVGProps } from 'react'

export const Github = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M9.99994 14.6668V12.0002C10.0927 11.165 9.85323 10.3269 9.33328 9.66683C11.3333 9.66683 13.3333 8.3335 13.3333 6.00016C13.3866 5.16683 13.1533 4.34683 12.6666 3.66683C12.8533 2.90016 12.8533 2.10016 12.6666 1.3335C12.6666 1.3335 11.9999 1.3335 10.6666 2.3335C8.90661 2.00016 7.09328 2.00016 5.33328 2.3335C3.99994 1.3335 3.33328 1.3335 3.33328 1.3335C3.13328 2.10016 3.13328 2.90016 3.33328 3.66683C2.84786 4.34409 2.61226 5.16869 2.66661 6.00016C2.66661 8.3335 4.66661 9.66683 6.66661 9.66683C6.40661 9.9935 6.21328 10.3668 6.09994 10.7668C5.98661 11.1668 5.95328 11.5868 5.99994 12.0002M5.99994 12.0002V14.6668M5.99994 12.0002C2.99328 13.3335 2.66659 10.6668 1.33325 10.6668'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
